























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import FormError from './FormError.vue';
import SelectOptionsComponent from '@/shared/components/SelectOptions.vue';
import { Option } from '../../../shared/models/view/option-viewmodel';

@Component({
    components: {
        FormError,
        SelectOptionsComponent
    },
    computed: {
        ...mapState(['form']),
        ...mapGetters('root', ['label'])
    }
})
export default class SelectOptionsSection extends Vue {
    @Prop() id!: string;
    @Prop() fieldLabel!: string;
    @Prop() required?: string;
    @Prop() placeholder?: string;
    @Prop() options?: Option[];
    @Prop() optionGroup?: boolean;

    private labelModule = 'SelfServiceVUnetID';

    private isValid(name: string): string {
        if (this.$store.getters.getFormErrors(name)) {
            return 'vuw-error';
        } return '';
    }

    private setFormValue(name: string, value: any): void {
        this.$store.commit('setFormValue', {name, value});
    }
}
